let LiteVimeoEmbed = (() => {
    class a extends HTMLElement {
      constructor() {
        super();
        this.iframeLoaded = !1;
        this.setupDom();
      }
  
      static get observedAttributes() {
        return ["videoid"];
      }
  
      connectedCallback() {
        this.addEventListener("pointerover", a.warmConnections, { once: !0 });
        this.addEventListener("click", () => this.addIframe());
      }
  
      get videoId() {
        return encodeURIComponent(this.getAttribute("videoid") || "");
      }
  
      set videoId(a) {
        this.setAttribute("videoid", a);
      }
  
      get videoTitle() {
        return this.getAttribute("videotitle") || "Video";
      }
  
      set videoTitle(a) {
        this.setAttribute("videotitle", a);
      }
  
      get videoPlay() {
        return this.getAttribute("videoPlay") || "Play";
      }
  
      set videoPlay(a) {
        this.setAttribute("videoPlay", a);
      }
  
      get videoStartAt() {
        return this.getAttribute("videoPlay") || "0s";
      }
  
      set videoStartAt(a) {
        this.setAttribute("videoPlay", a);
      }
  
      get autoLoad() {
        return this.hasAttribute("autoload");
      }
  
      set autoLoad(a) {
        a ? this.setAttribute("autoload", "") : this.removeAttribute("autoload");
      }
  
      get autoPlay() {
        return this.hasAttribute("autoplay");
      }
  
      set autoPlay(a) {
        a ? this.setAttribute("autoplay", "autoplay") : this.removeAttribute("autoplay");
      }
  
      setupDom() {
        let a = this.attachShadow({ mode: "open" });
        a.innerHTML = `
      <style>
      :host {
          contain: content;
          display: block;
          position: relative;
          width: 100%;
          padding-bottom: calc(100% / (16 / 9)); /* Default aspect ratio (16:9) */
      }
      @media (max-width: 768px) {
          :host {
              padding-bottom: 100%; /* Makes the container square on mobile */
          }
      }
      #fallbackPlaceholder, #frame, iframe {
          position: absolute;
          width: 100%;
          height: 100%;
      }
      @media (max-width: 768px) {
          iframe {
              width: 100%;
              height: 100%;
              object-fit: cover; /* Ensures the video fills the square container */
          }
        #frame .player .vp-video-wrapper object, frame .player .vp-video-wrapper video {
            width: unset !important;
        }
        #frame #player {
            height: unset !important;
        }
      }

      #frame {
          cursor: pointer;
      }
      #fallbackPlaceholder {
          object-fit: cover;
      }
      .lvo-playbtn {
          width: 70px;
          height: 46px;
          background-color: #353535;
          z-index: 1;
          opacity: .8;
          border-radius: 10%;
          transition: .2s cubic-bezier(0, 0, .2, 1);
          border: 0;
      }
      #frame:hover .lvo-playbtn {
          background-color: #62afed;
          opacity: 1;
          display: none;
      }
      .lvo-playbtn:before {
          content: '';
          border-style: solid;
          border-width: 11px 0 11px 19px;
          border-color: transparent transparent transparent #fff;
      }
      .lvo-playbtn, .lvo-playbtn:before {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate3d(-50%, -50%, 0);
          display: none;
      }
      .lvo-activated {
          cursor: unset;
      }
      #frame.lvo-activated::before, .lvo-activated .lvo-playbtn {
          display: none;
      }
      </style>
      <div id="frame">
          <button class="lvo-playbtn"></button>
      </div>
        `;
        this.domRefFrame = this.shadowRoot.querySelector("#frame");
        this.domRefImg = {
          fallback: this.shadowRoot.querySelector("#fallbackPlaceholder"),
          webp: this.shadowRoot.querySelector("#webpPlaceholder"),
          jpeg: this.shadowRoot.querySelector("#jpegPlaceholder"),
        };
        this.domRefPlayButton = this.shadowRoot.querySelector(".lvo-playbtn");
      }
  
      setupComponent() {
        this.initImagePlaceholder();
        this.domRefPlayButton.setAttribute("aria-label", `${this.videoPlay}: ${this.videoTitle}`);
        this.setAttribute("title", `${this.videoPlay}: ${this.videoTitle}`);
        this.autoLoad && this.initIntersectionObserver();
      }
  
      attributeChangedCallback(a, b, c) {
        "videoid" === a &&
          b !== c &&
          (this.setupComponent(),
          this.domRefFrame.classList.contains("lvo-activated") &&
            (this.domRefFrame.classList.remove("lvo-activated"),
            this.shadowRoot.querySelector("iframe").remove()));
      }
  
      addIframe() {
        if (!this.iframeLoaded) {
            let autoplayParam = this.autoLoad && this.autoPlay || !this.autoLoad ? "autoplay=1" : "";
            let videoUrl = new URL(`/video/${this.videoId}?${autoplayParam}&#t=${this.videoStartAt}`, "https://player.vimeo.com/");
            let iframeHtml = `
                <iframe frameborder="0" id="vimeo-iframe"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                    allowfullscreen
                    src="${videoUrl}"
                    style="width: 100%; height: 100%;"></iframe>`;
            this.domRefFrame.insertAdjacentHTML("beforeend", iframeHtml);
            this.domRefFrame.classList.add("lvo-activated");
            this.iframeLoaded = true;
    
            // Enforce styles on the iframe
            const iframe = this.shadowRoot.querySelector("#vimeo-iframe");
            if (iframe) {
                iframe.style.width = "100%";
                iframe.style.height = "100%";
                iframe.style.objectFit = "cover"; // Ensures the video fills the container
    
                // Inject CSS into the iframe
                iframe.onload = () => {
                    const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
                    const style = iframeDocument.createElement("style");
                    style.textContent = `
                        @media screen and (max-width: 678px) {
                            .player .vp-video-wrapper object, 
                            .player .vp-video-wrapper video {
                                width: unset !important;
                            }
                            #player {
                                height: unset !important;
                            }
                        }
                    `;
                    iframeDocument.head.appendChild(style);
                };
            }
        }
    }
  
    async initImagePlaceholder() {
        a.addPrefetch("preconnect", "https://i.vimeocdn.com/");
        try {
            let response = await fetch(`https://vimeo.com/api/v2/video/${this.videoId}.json`);
            let data = await response.json();
            let thumbnailUrl = data[0].thumbnail_large;
    
            // Check if fallback element exists
            if (this.domRefImg.fallback) {
                this.domRefImg.fallback.setAttribute("aria-label", `${this.videoPlay}: ${this.videoTitle}`);
                this.domRefImg.fallback.setAttribute("alt", `${this.videoPlay}: ${this.videoTitle}`);
                this.domRefImg.fallback.setAttribute("src", thumbnailUrl);
            } else {
                console.warn("Fallback placeholder element not found in the shadow DOM.");
            }
        } catch (error) {
            console.error("Failed to fetch video thumbnail:", error);
        }
    }
  
      initIntersectionObserver() {
        if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window) {
          let b = { root: null, rootMargin: "0px", threshold: 0 },
            c = new IntersectionObserver((b, c) => {
              b.forEach((b) => {
                b.isIntersecting &&
                  !this.iframeLoaded &&
                  (a.warmConnections(), this.addIframe(), c.unobserve(this));
              });
            }, b);
          c.observe(this);
        }
      }
  
      static addPrefetch(c, d, b) {
        let a = document.createElement("link");
        a.rel = c;
        a.href = d;
        b && (a.as = b);
        a.crossOrigin = "true";
        document.head.append(a);
      }
  
      static warmConnections() {
        a.preconnected ||
          (a.addPrefetch("preconnect", "https://f.vimeocdn.com"),
          a.addPrefetch("preconnect", "https://player.vimeo.com"),
          a.addPrefetch("preconnect", "https://i.vimeocdn.com"),
          (a.preconnected = !0));
      }
    }
    return (a.preconnected = !1), a;
  })();
  customElements.define("lite-vimeo", LiteVimeoEmbed);
  export { LiteVimeoEmbed };